export const form = {
  FIRST_NAME: 'FirstName',
  LAST_NAME: 'LastName',
  EMAIL: 'Email',
  PHONE: 'MobilePhone',
  LOCATION_CITY: 'MailingCity',
  LOCATION_STATE: 'MailingState',
  NOTES: 'Message__c'
};

export const initialValues = {
  [form.FIRST_NAME]: '',
  [form.LAST_NAME]: '',
  [form.EMAIL]: '',
  [form.PHONE]: '',
  [form.LOCATION_CITY]: '',
  [form.LOCATION_STATE]: '',
  [form.NOTES]: ''
};
